import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-transfer-grid-page',
  templateUrl: './transfer-grid-page.component.html',
  styleUrls: ['./transfer-grid-page.component.scss'],
})
export class TransferGridPageComponent {}
